/**
 * pdp.js — phần riêng của trang chi tiết sản phẩm (mục 15) mà các module chung không lo:
 *   1. Đổi "Dung tích" → cập nhật giá bán, giá gốc, % tiết kiệm, badge −% trên ảnh
 *      và giá ở thanh hành động mobile.
 *   2. Đồng bộ thanh hành động mobile với khối mua hàng: js/cart.js chỉ đọc dung tích và
 *      số lượng trong [data-product] GẦN NHẤT, mà thanh nằm ngoài khối đó — nên chép
 *      lựa chọn hiện tại vào data-variant / data-price / data-regular-price (WBStore.product
 *      đọc các data-* này) và ô ẩn [data-qty-source] của thanh.
 *   3. Khối Mô tả / Thông số / … ([data-pdp-block]): dưới md là accordion (mở sẵn khối đầu,
 *      bấm tiêu đề để gập/mở); từ md luôn mở, tiêu đề ra khỏi tab order. Mục lục dính
 *      ([data-pdp-nav]) tô mục đang đọc. Link tới một khối (mục lục, "128 đánh giá" #reviews,
 *      mở trang kèm #hash) thì mở khối đó trước rồi mới cuộn — khối đang gập thì không cuộn tới được.
 *   4. Tooltip nhãn "Hương vị" trên màn cảm ứng: chạm để bật/tắt (CSS chỉ mở bằng
 *      hover / focus-visible, cả hai đều không xảy ra khi chạm). Esc để đóng.
 *   5. Gói quà: tick thì hiện ô lời nhắn trên thiệp.
 *   6. Thanh hành động mobile chỉ hiện khi nút mua chính đã cuộn qua khỏi màn hình (.is-tucked
 *      khi chưa) — trước đó trùng bộ nút ngay trên màn. Không có JS thì luôn hiện.
 *
 * Markup: form[data-pdp-form] (input[name="variant"][data-price][data-regular-price],
 *         [data-qty-source], [data-pdp-gift] + [data-pdp-gift-note]) · [data-pdp-price]
 *         · [data-pdp-regular] · [data-pdp-percent] · [data-pdp-sale] · [data-pdp-variant-label]
 *         · [data-pdp-bar] (+ [data-pdp-bar-qty]) · [data-pdp-block] > [data-pdp-block-toggle]
 *         · [data-pdp-nav] > a[href^="#"] · a[href="#reviews"] · [data-tooltip]
 *
 * WP: WooCommerce bắn sự kiện jQuery `found_variation` trên form.variations_form kèm
 * display_price / display_regular_price — đổi phần (1) sang nghe sự kiện đó; phần (3)
 * thay bằng .woocommerce-review-link có sẵn trong wc-single-product.js.
 *
 * Viết theo cú pháp ES5 vì pipeline dùng uglify-js sau babel.
 */
(function () {
    'use strict';

    var form = document.querySelector('[data-pdp-form]');
    var bar = document.querySelector('[data-pdp-bar]');
    var blocks = [].slice.call(document.querySelectorAll('[data-pdp-block]'));
    var nav = document.querySelector('[data-pdp-nav]');
    // 1024px = mq(md) trong SCSS — mốc CSS đổi accordion ↔ cuộn liền, JS phải trùng đúng mốc đó
    var desktop = window.matchMedia ? window.matchMedia('(min-width: 1024px)') : { matches: true };

    function each(selector, fn) {
        [].slice.call(document.querySelectorAll(selector)).forEach(fn);
    }

    // store.js nạp SAU file này (gulp gộp theo chữ cái) — gọi lười lúc người dùng bấm
    function money(value) {
        if (window.WBStore) return window.WBStore.money(value);
        return Math.round(Number(value) || 0).toLocaleString('vi-VN') + '₫';
    }

    // Không khai giá gốc thì suy ra như guideline: giá × 1.25, làm tròn chục nghìn
    function regularOf(input, price) {
        var regular = Number(input.getAttribute('data-regular-price'));
        return regular > 0 ? regular : Math.round((price * 1.25) / 10000) * 10000;
    }

    // ----- 1 + 2. Dung tích → giá -----
    function applyVariant(input) {
        var price = Number(input.getAttribute('data-price'));
        if (!price) return;
        var regular = regularOf(input, price);
        var percent = regular > price ? Math.round((1 - price / regular) * 100) : 0;

        each('[data-pdp-price]', function (el) {
            el.textContent = money(price);
        });
        each('[data-pdp-regular]', function (el) {
            el.textContent = money(regular);
            var del = el.closest('del');
            if (del) del.hidden = percent === 0;
        });
        each('[data-pdp-percent]', function (el) {
            el.textContent = percent + '%';
            var badge = el.closest('.badge');
            if (badge) badge.hidden = percent === 0;
        });
        each('[data-pdp-sale]', function (el) {
            el.textContent = '−' + percent + '%';
            el.hidden = percent === 0;
        });
        each('[data-pdp-variant-label]', function (el) {
            el.textContent = input.value;
        });

        if (bar) {
            bar.setAttribute('data-variant', input.value);
            bar.setAttribute('data-price', String(price));
            bar.setAttribute('data-regular-price', String(regular));
        }
    }

    function syncQty(source) {
        var target = bar ? bar.querySelector('[data-pdp-bar-qty]') : null;
        if (!target) return;
        var qty = parseInt(source.value, 10);
        target.value = isNaN(qty) || qty < 1 ? 1 : qty;
    }

    if (form) {
        form.addEventListener('change', function (event) {
            var target = event.target;
            if (target.name === 'variant') applyVariant(target);
            if (target.hasAttribute('data-qty-source')) syncQty(target);
        });

        // Gõ tay số lượng: 'change' chỉ bắn khi rời ô, nên nghe thêm 'input'
        form.addEventListener('input', function (event) {
            if (event.target.hasAttribute('data-qty-source')) syncQty(event.target);
        });

        // F5 giữ lựa chọn cũ của trình duyệt — vẽ giá theo đúng ô đang chọn
        var checked = form.querySelector('input[name="variant"]:checked');
        if (checked) applyVariant(checked);
        var qty = form.querySelector('[data-qty-source]');
        if (qty) syncQty(qty);
    }

    // ----- 3. Khối nội dung: accordion mobile · mục lục dính · nhảy tới khối -----
    function toggleOf(block) {
        return block.querySelector('[data-pdp-block-toggle]');
    }

    function setBlock(block, open) {
        block.classList.toggle('is-collapsed', !open);
        var toggle = toggleOf(block);
        if (toggle) toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    }

    // Đổi khổ màn hình: desktop mở hết + bỏ tiêu đề khỏi tab order; mobile chỉ mở khối đầu
    function layoutBlocks() {
        blocks.forEach(function (block, i) {
            var toggle = toggleOf(block);
            if (desktop.matches) {
                setBlock(block, true);
                if (toggle) toggle.setAttribute('tabindex', '-1');
            } else {
                setBlock(block, i === 0);
                if (toggle) toggle.removeAttribute('tabindex');
            }
        });
    }

    blocks.forEach(function (block) {
        var toggle = toggleOf(block);
        if (!toggle) return;
        toggle.addEventListener('click', function () {
            if (desktop.matches) return;
            setBlock(block, block.classList.contains('is-collapsed'));
        });
    });

    if (blocks.length) {
        layoutBlocks();
        if (desktop.addEventListener) desktop.addEventListener('change', layoutBlocks);
    }

    function markNav(id) {
        if (!nav) return;
        [].slice.call(nav.querySelectorAll('a[href^="#"]')).forEach(function (a) {
            if (a.getAttribute('href') === '#' + id) a.setAttribute('aria-current', 'true');
            else a.removeAttribute('aria-current');
        });
    }

    // Phần che mép trên khung nhìn khi đã cuộn: header dính (--header-height, js/navigation.js)
    // + hàng tab dính (desktop). Đo lúc cần vì header co lại khi cuộn.
    function topCover() {
        var header = parseFloat(window.getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 0;
        return header + (nav && desktop.matches ? nav.offsetHeight : 0);
    }

    // Phần tử đích (#reviews nằm TRONG khối Đánh giá) → khối chứa nó: mở rồi cuộn tới.
    // Tự tính vị trí thay vì scrollIntoView + scroll-margin: --header-height lúc bấm là header còn
    // cao (chưa co), cộng thêm hàng tab thì khối dừng cách tab cả trăm px.
    function openTarget(id, smooth) {
        var target = id ? document.getElementById(id) : null;
        var block = target ? target.closest('[data-pdp-block]') : null;
        if (!block) return false;
        setBlock(block, true);
        // Đích là chính khối hoặc mở đầu thân khối (#reviews) → cuộn tới đầu khối để thấy tiêu đề;
        // đích nằm giữa khối (heading mục lục mô tả, #faq-giao-hang) → cuộn tới đúng chỗ đó
        var body = block.querySelector('.pdp-block__body');
        var anchor = target === block || (body && body.firstElementChild === target) ? block : target;
        var top = anchor.getBoundingClientRect().top + window.pageYOffset - topCover() + (anchor === block ? 1 : -16);
        window.scrollTo({ top: Math.max(0, top), behavior: smooth ? 'smooth' : 'auto' });
        return true;
    }

    document.addEventListener('click', function (event) {
        var link = event.target.closest ? event.target.closest('a[href^="#"]') : null;
        if (!link) return;
        var id = link.getAttribute('href').slice(1);
        if (!openTarget(id, true)) return;
        event.preventDefault();
        // Tô ngay mục vừa bấm — đợi cuộn mượt xong mới tô thì mục lục trễ cả giây
        if (nav && nav.contains(link)) markNav(id);
        if (window.history && window.history.replaceState) window.history.replaceState(null, '', '#' + id);
    });

    // Mở trang kèm #reviews / #comment-123 (link "(128)" từ card sản phẩm) hoặc #tab-…
    document.addEventListener('DOMContentLoaded', function () {
        var hash = window.location.hash.slice(1);
        if (/^comment-\d+$/.test(hash)) hash = 'reviews';
        if (hash) openTarget(hash, false);
    });

    // Mục lục: tô mục của khối đang chiếm phần trên khung nhìn
    if (nav && blocks.length && 'IntersectionObserver' in window) {
        // Vạch 1px ngay dưới hàng tab: khối nào đang nằm dưới vạch đó là khối đang đọc.
        // Dựng lại khi đổi khổ màn (chiều cao header / hàng tab đổi).
        var spy = null;
        var watch = function () {
            if (spy) spy.disconnect();
            var line = Math.round(topCover() + 24);
            spy = new IntersectionObserver(
                function (entries) {
                    entries.forEach(function (entry) {
                        if (entry.isIntersecting) markNav(entry.target.id);
                    });
                },
                { rootMargin: -line + 'px 0px ' + -(window.innerHeight - line - 1) + 'px 0px' }
            );
            blocks.forEach(function (block) {
                spy.observe(block);
            });
        };
        watch();
        var resizeTimer;
        window.addEventListener('resize', function () {
            window.clearTimeout(resizeTimer);
            resizeTimer = window.setTimeout(watch, 200);
        });
    }

    // ----- 4. Tooltip chạm để mở -----
    function closeTooltips(except) {
        each('[data-tooltip].is-open', function (el) {
            if (el !== except) el.classList.remove('is-open');
        });
    }

    document.addEventListener('click', function (event) {
        var trigger = event.target.closest ? event.target.closest('[data-tooltip]') : null;
        closeTooltips(trigger);
        if (trigger) trigger.classList.toggle('is-open');
    });

    document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' || event.key === 'Esc') closeTooltips(null);
    });

    // ----- 5. Gói quà → ô lời nhắn -----
    var gift = form ? form.querySelector('[data-pdp-gift]') : null;
    var giftNote = form ? form.querySelector('[data-pdp-gift-note]') : null;
    if (gift && giftNote) {
        var syncGift = function () {
            giftNote.hidden = !gift.checked;
            gift.setAttribute('aria-expanded', gift.checked ? 'true' : 'false');
        };
        gift.addEventListener('change', syncGift);
        syncGift();
    }

    // ----- 6. Thanh hành động mobile hiện khi nút mua chính đã cuộn qua -----
    // Đo vị trí nút mỗi lần cuộn (gộp theo khung hình), KHÔNG dùng IntersectionObserver: IO chỉ báo khi nút đổi
    // trạng thái giao với khung nhìn — nhảy thẳng qua nút (bấm mục lục, link "128 đánh giá", về đầu trang) thì
    // nút đi từ "dưới khung" sang "trên khung" mà không lúc nào giao ⇒ không có callback, thanh kẹt sai trạng thái.
    var buy = document.querySelector('.pdp-buy');
    if (bar && buy) {
        var ticking = false;
        var place = function () {
            ticking = false;
            // Hiện khi nút đã khuất PHÍA TRÊN — kể cả khi còn nằm sau header dính (khách không thấy nó nữa);
            // nút còn ở dưới (chưa cuộn tới) hoặc đang trên màn thì ẩn để không trùng hai bộ nút
            bar.classList.toggle('is-tucked', buy.getBoundingClientRect().bottom > topCover());
        };
        var request = function () {
            if (ticking) return;
            ticking = true;
            window.requestAnimationFrame(place);
        };
        window.addEventListener('scroll', request, { passive: true });
        window.addEventListener('resize', request);
        place();
    }
})();
